module.exports = __webpack_public_path__ + "img/add-token-image.71d795da.png";